import type { GameState } from '@cc/shared';

export function EntitlementChips({ state, selected, onPay, onMove, onCapture }: { state: GameState; selected?: string | undefined; onPay: () => void; onMove: () => void; onCapture: () => void }) {
  const entitlements = state.entitlements;
  if (state.phase !== 'actions') return null;
  return <div className="entitlement-chips">
    {entitlements.placeRemaining > 0 && <span className="entitlement-chip">Place ×{entitlements.placeRemaining}</span>}
    {entitlements.mayPay && <button className={`entitlement-chip ${selected === 'pay' ? 'is-selected' : ''}`} onClick={onPay}>Pay → Place 3</button>}
    {entitlements.mayMove && <button className={`entitlement-chip ${selected === 'move' ? 'is-selected' : ''}`} onClick={onMove}>Move</button>}
    {entitlements.mayCapture && <button className={`entitlement-chip ${selected === 'capture' ? 'is-selected' : ''}`} onClick={onCapture}>Capture</button>}
  </div>;
}
